import MojitoCore from 'mojito/core';
import PasswordChangeImpl from './password-change-controller-view.js';
const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * A module responsible for handling payments.
 *
 * @class PasswordChange
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules
 */

export default UIControllerView('PasswordChange', PasswordChangeImpl);
